<template>
  <main dir="rtl" class="flex-1 pb-8">
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="mb-6">
        <h1 class="text-3xl font-bold text-primary">سجل دخول طلاب الحلقات العامة</h1>
      </div>

      <div v-if="error" class="mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
        {{ error }}
      </div>

      <div class="bg-white rounded-lg shadow overflow-hidden">
        <div class="p-4 border-b border-gray-200 grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
          <div>
            <label class="block mb-1 text-sm text-gray-700">الحلقة</label>
            <select v-model="filters.circleId" class="w-full px-3 py-2 border rounded">
              <option value="">كل الحلقات</option>
              <option v-for="circle in circles" :key="circle.id" :value="circle.id">
                {{ circle.title }}
              </option>
            </select>
          </div>
          <div>
            <label class="block mb-1 text-sm text-gray-700">اليوم</label>
            <input v-model="filters.date" type="date" class="w-full px-3 py-2 border rounded" />
          </div>
          <div class="md:col-span-2 flex gap-2">
            <button class="px-4 py-2 bg-primary text-white rounded hover:bg-primary-dark" @click="loadLogs">
              تحديث
            </button>
            <button class="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200" @click="resetFilters">
              إعادة ضبط
            </button>
          </div>
        </div>

        <div v-if="loading" class="text-center py-10 text-gray-500">جاري التحميل...</div>

        <div v-else class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-secondary text-white">
              <tr>
                <th class="px-4 py-3 text-center text-xs">الحلقة</th>
                <th class="px-4 py-3 text-center text-xs">المعلم</th>
                <th class="px-4 py-3 text-center text-xs">الطالب</th>
                <th class="px-4 py-3 text-center text-xs">وقت الدخول</th>
                <th class="px-4 py-3 text-center text-xs">وقت الخروج</th>
                <th class="px-4 py-3 text-center text-xs">المدة (دقيقة)</th>
                <th class="px-4 py-3 text-center text-xs">الحالة</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              <tr v-for="item in items" :key="item.id" class="hover:bg-gray-50">
                <td class="px-4 py-3 text-sm text-center">{{ item.circleTitle || '-' }}</td>
                <td class="px-4 py-3 text-sm text-center">{{ item.teacherName || '-' }}</td>
                <td class="px-4 py-3 text-sm text-center">{{ item.studentName || '-' }}</td>
                <td class="px-4 py-3 text-sm text-center">{{ item.joinedAt || '-' }}</td>
                <td class="px-4 py-3 text-sm text-center">{{ item.leftAt || '-' }}</td>
                <td class="px-4 py-3 text-sm text-center">{{ formatDurationMinutes(item) }}</td>
                <td class="px-4 py-3 text-sm text-center">
                  <span
                    class="px-2 py-1 rounded-full text-xs"
                    :class="item.isInsideNow ? 'bg-green-100 text-green-700' : 'bg-gray-200 text-gray-700'"
                  >
                    {{ item.isInsideNow ? 'داخل الآن' : 'خرج' }}
                  </span>
                </td>
              </tr>
              <tr v-if="items.length === 0">
                <td colspan="7" class="px-4 py-6 text-center text-gray-500">لا توجد سجلات في هذا اليوم</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { getPublicCircleAttendanceLogs, getPublicCircles } from '@/services/publicCircles';

const today = () => new Date().toISOString().slice(0, 10);

export default {
  name: 'PublicCircleAttendanceLogs',
  data() {
    return {
      loading: false,
      error: '',
      circles: [],
      items: [],
      filters: {
        circleId: '',
        date: today(),
      },
    };
  },
  async mounted() {
    await Promise.all([this.loadCircles(), this.loadLogs()]);
  },
  methods: {
    async loadCircles() {
      try {
        this.circles = await getPublicCircles();
      } catch (error) {
        this.circles = [];
      }
    },
    async loadLogs() {
      this.loading = true;
      this.error = '';
      try {
        const result = await getPublicCircleAttendanceLogs({
          circleId: this.filters.circleId || undefined,
          date: this.filters.date || undefined,
        });
        this.items = result?.items || [];
      } catch (error) {
        this.error = error?.response?.data?.result?.mesAr || 'فشل تحميل سجل الحضور';
      } finally {
        this.loading = false;
      }
    },
    resetFilters() {
      this.filters = { circleId: '', date: today() };
      this.loadLogs();
    },
    formatDurationMinutes(item) {
      const fromSeconds = Number(item?.durationSeconds || 0);
      let seconds = Number.isFinite(fromSeconds) ? fromSeconds : 0;

      if (seconds <= 0 && item?.joinedAt && item?.leftAt) {
        const joined = new Date(item.joinedAt).getTime();
        const left = new Date(item.leftAt).getTime();
        if (!Number.isNaN(joined) && !Number.isNaN(left) && left >= joined) {
          seconds = Math.floor((left - joined) / 1000);
        }
      }

      return (seconds / 60).toFixed(2);
    },
  },
};
</script>

<style scoped>
.text-primary {
  color: #c9a06c;
}
.bg-primary {
  background-color: #c9a06c;
}
.bg-primary-dark {
  background-color: #b8956a;
}
.bg-secondary {
  background-color: #d4a574;
}
</style>

